<template>
    <div id="app" class="app-main" v-cloak>
        <router-view />
    </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
    name: "app",
    // components: {
    //   HelloWorld
    // }
    created(){
        const token = localStorage.getItem('token');
        const loginTime = parseInt(localStorage.getItem('loginTime') || '0');
        if (token && loginTime){
            if (this.$store.state.TimeoutTimerId) { //清除之前的定时器，重新开一个新的
                clearTimeout(this.$store.state.TimeoutTimerId);
                this.$store.commit('setTimeoutTimerId', null);
            }
            const loginTime = parseInt(localStorage.getItem('loginTime') || '0');
            // 设置的日期应该是 7天 - 当前时间 - 登录时间
            // 604800000
            const time = (604800000 - (new Date().getTime() - loginTime)) < 0 ? 0 : 604800000 - (new Date().getTime() - loginTime);
            const timerId = setTimeout(() => {
                this.$message.error('登录超时，请重新登录');
                this.$store.commit('loginOut');
                window.location.href = '/#/login';
            }, time);
            this.$store.commit('setTimeoutTimerId', timerId);
        }
    },
};
</script>

<style lang="scss" scoped>
.app-main {
    width: 100%;
    height: 100vh;
}
[v-cloak] {
    display: none;
}
</style>
